import "client-only"

import { FlowKey, flowsMapping } from "@/config/flows"
import { usePathname } from "next/navigation"
import { PushNavigateOptions, useConfigParams, useNavigation } from "."

const useFlow = () => {
  /*--------------------hooks--------------------*/
  const { flow, fromPdv } = useConfigParams()
  const pathName = usePathname()
  const router = useNavigation()

  /*--------------------config--------------------*/
  const actualFlowName = fromPdv ? "C1PDV" : (flow as FlowKey)
  const currentFlow = flowsMapping[actualFlowName]
  const currentStep = currentFlow?.find((step) => pathName === step.path)

  const initialFlowPath = {
    C1: "/codice-fiscale",
    C1PDV: "/registrazione-pdv",
    OCR: "/",
    OCRPDV: "/registrazione-semplificata-pdv",
  }[actualFlowName ?? "C1"]

  /*--------------------helpers--------------------*/

  const goToFirstStep = () => router.replace(initialFlowPath)
  const goToNextStep = (options?: PushNavigateOptions) =>
    router.push(
      currentStep?.nextStepPath || "/errore?flow=no-flow",
      options
        ? { ...options, scroll: options?.scroll ?? true }
        : { scroll: true },
    )
  const goToPrevStep = (options?: PushNavigateOptions) =>
    router.push(
      currentStep?.prevStepPath || "/errore?flow=no-flow",
      options
        ? { ...options, scroll: options?.scroll ?? true }
        : { scroll: true },
    )
  const findMultiStepPath = (step: string) =>
    currentFlow.find((flowStep) => flowStep.path.includes(step))?.path ||
    "/errore?flow=no-flow"

  return {
    currentFlow,
    actualFlowName,
    initialFlowPath,
    goToFirstStep,
    goToNextStep,
    goToPrevStep,
    findMultiStepPath,
  }
}

export { useFlow }
